import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded shadow fixed bottom-1 right-1 border z-40 p-4 pb-0 m-2 max-w-sm w-full"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "items-center flex" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!

  return (_ctx.showFeaturePanel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featureList, (feature, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `feature-${i}`,
            class: "flex mb-4"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("b", null, _toDisplayString(feature.name.replace(/_/g, ' ')), 1),
              _createElementVNode("div", null, _toDisplayString(feature.description), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (feature.isToggleable)
                ? (_openBlock(), _createBlock(_component_Switch, {
                    key: feature.name,
                    "current-value": feature.enabled,
                    onToggle: (toggle) => _ctx.methods.toggleFeature(feature.name, toggle)
                  }, null, 8, ["current-value", "onToggle"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(feature.enabled ? 'Enabled' : 'Disabled'), 1))
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}